import React, { FC, cloneElement, Children, ReactElement } from 'react';
import { PrivacyAllowanceLayerProps } from './models';
import { PrivacyOptions } from '@sunbit-dev/common/enums/Datadog';
import { privacyOptionsClassNames } from '@sunbit-dev/common/services/datadog';
import classNames from 'classnames';

export const PrivacyAllowanceLayer: FC<PrivacyAllowanceLayerProps> = ({ children, privacyLevel }) => {
  const privacyLevelClassName = privacyOptionsClassNames[privacyLevel || PrivacyOptions.Allow];

  return (
    <>
      {Children.map(children, (child: ReactElement) => {
        if (child) return cloneElement(child, { className: classNames(child.props.className, privacyLevelClassName) });

        return child;
      })}
    </>
  );
};
